var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#paint0_linear_316_872)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2722 35.1594V29.8185C53.2722 28.0075 51.8675 26.5347 50.0927 26.3919L45.1328 17.7287C44.6731 16.9274 43.9309 16.3548 43.0428 16.117C42.1589 15.8808 41.2346 16.0049 40.4435 16.4653L23.4407 26.364H20.4545C18.5493 26.364 17 27.9133 17 29.8185V50.5455C17 52.4507 18.5493 54 20.4545 54H49.8177C51.7229 54 53.2722 52.4507 53.2722 50.5455V45.2047C54.2753 44.847 54.9994 43.8973 54.9994 42.7729V37.5911C54.9994 36.4667 54.2753 35.5171 53.2722 35.1594ZM48.0856 26.364H40.5583L46.2038 23.0772L48.0856 26.364ZM45.3457 21.5783L37.1254 26.364H33.7158L44.4931 20.0893L45.3457 21.5783ZM41.313 17.958C41.7035 17.7295 42.1597 17.6688 42.5958 17.7852C43.0369 17.9032 43.4047 18.1883 43.6332 18.5872L43.635 18.5904L30.2831 26.364H26.8736L41.313 17.958ZM51.5449 50.5455C51.5449 51.4976 50.7698 52.2727 49.8177 52.2727H20.4545C19.5024 52.2727 18.7273 51.4976 18.7273 50.5455V29.8185C18.7273 28.8664 19.5024 28.0913 20.4545 28.0913H49.8177C50.7698 28.0913 51.5449 28.8664 51.5449 29.8185V35.0003H46.3632C43.5058 35.0003 41.1815 37.3246 41.1815 40.182C41.1815 43.0394 43.5058 45.3637 46.3632 45.3637H51.5449V50.5455ZM53.2722 42.7729C53.2722 43.2494 52.8851 43.6365 52.4086 43.6365H46.3632C44.458 43.6365 42.9087 42.0873 42.9087 40.182C42.9087 38.2768 44.4579 36.7275 46.3632 36.7275H52.4086C52.885 36.7275 53.2722 37.1146 53.2722 37.5911V42.7729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3639 38.4551C45.4118 38.4551 44.6367 39.2302 44.6367 40.1823C44.6367 41.1344 45.4118 41.9095 46.3639 41.9095C47.3161 41.9095 48.0912 41.1344 48.0912 40.1823C48.0912 39.2302 47.3162 38.4551 46.3639 38.4551Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_872",
    x1: 36,
    y1: 0,
    x2: 36,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(17 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralStep1);
export default __webpack_public_path__ + "static/media/referral-step-1.63fa41fe7d3c69c01a736ddf215b13f6.svg";
export { ForwardRef as ReactComponent };